// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mask-preview-render[data-v-78841876]{position:relative;background:url(https://static-production.gocase.com.br/transparency.png);background-size:cover;mask-size:100% 100%;mask-repeat:no-repeat;-webkit-mask-size:100% 100%;-webkit-mask-repeat:no-repeat;-o-mask-size:100% 100%;-o-mask-repeat:no-repeat;-moz-mask-size:100% 100%;-moz-mask-repeat:no-repeat}", ""]);
// Exports
module.exports = exports;
